import { useEffect, useCallback } from 'react'
import debounce from 'lodash/debounce'

const DEBOUNCE_TIME = 300

const useCommon = () => {
  const useDebouncedEffect = (effect: () => void, deps: any[], delay = 300) => {
    const debouncedEffect = useCallback(debounce(effect, delay), deps)

    useEffect(() => {
      debouncedEffect()

      return () => {
        debouncedEffect.cancel()
      }
    }, [debouncedEffect])
  }

  return {
    useDebouncedEffect
  }
}

export default useCommon
